export default __webpack_public_path__ + "static/media/responsive_CDR.df6aa5d3.webp";